import React from 'react';
import { Hero } from '../components/Hero';
import { TrustSection } from '../components/TrustSection';
import { Programs } from '../components/Programs';
import { Benefits } from '../components/Benefits';
import { Reviews } from '../components/Reviews';
import { AreasServed } from '../components/AreasServed';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <Hero data-id="element-313" />
      <TrustSection data-id="element-314" />
      <Programs data-id="element-315" />
      <Benefits data-id="element-316" />
      <Reviews data-id="element-317" />
      <AreasServed data-id="element-318" />
      <FinalCTA data-id="element-319" />
    </>;
}